import Vue from 'vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {BootstrapVue} from 'bootstrap-vue';
import Vue2Filters from 'vue2-filters';
import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import wb from "./registerServiceWorker";
import '@/assets/util.css';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
// import '@/assets/yeti.min.css';

import {
    faUserSecret,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faChevronDown,
    faCamera,
    faTasks,
    faSave,
    faFlagUsa,
    faClipboardCheck,
    faPencilAlt,
    faDownload,
    faAsterisk,
    faSignInAlt,
    faUser,
    faSignOutAlt,
    faInbox,
    faBoxes,
    faStopwatch,
    faSpinner,
    faCheckCircle,
    faImages,
} from '@fortawesome/free-solid-svg-icons'

library.add(faUserSecret, faChevronRight, faChevronLeft, faChevronUp,
    faChevronDown, faCamera, faTasks, faSave, faFlagUsa, faClipboardCheck,
    faPencilAlt, faDownload, faAsterisk, faSignInAlt, faUser, faSignOutAlt,
    faInbox, faBoxes, faStopwatch, faSpinner, faCheckCircle, faImages);

Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.prototype.$workbox = wb;

Vue.prototype.$toastSuccess = {
    title: `Success`,
    variant: 'success',
    autoHideDelay: 1000,
    solid: true
};
Vue.prototype.$toastError = {
    title: `Error`,
    variant: 'danger',
    // autoHideDelay: 1000,
    solid: true
};

if (window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.1.69')
    axios.defaults.baseURL = location.protocol + '//' + window.location.host + '/api/inspection';
else
    axios.defaults.baseURL = location.protocol + '//' + window.location.hostname + ':9091/api/inspection';

axios.interceptors.request.use((config) => {
    config.headers['X-Token'] = (JSON.parse(localStorage.getItem('idata')) ?
        JSON.parse(localStorage.getItem('idata')).token : '');
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
}, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const vm = new Vue();
    let status = error.response.status;
    switch (status) {
        case 401:
            localStorage.removeItem('idata');
            location.href = "/";
            break;
        case 500:
            break;
    }
    if (status !== 404)
        vm.$bvToast.toast(`ERROR ${status}: ${error.response.data.msg}`, Vue.prototype.$toastError);
    return Promise.reject(error);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
